// © Microsoft Corporation. All rights reserved.
import { __decorate } from "tslib";
import { TreeItem } from "@microsoft/fast-foundation";
import { attr } from "@microsoft/fast-element";
export class HamburgerMenuItem extends TreeItem {
    constructor() {
        super(...arguments);
        /**
         * Handles clicks on the hamburger menu item
         * @param e - mouse event
         */
        this.handleClick = (e) => {
            if (!e.defaultPrevented && !this.disabled) {
                this.handleMenuItemSelection(e);
            }
        };
    }
    /**
     * Handles menu item selection. For hamburger menu, we don't want users to be able to deselect items so we use this
     * method to protect against that. Emits a custom selected-change event
     * @param e - mouse or keyboard event
     */
    handleMenuItemSelection(e) {
        if (this.selected) {
            return;
        }
        this.selected = !this.selected;
        // Keeping as "selected-change" event because TreeView and TreeItem depend on that event in their base classes
        this.$emit("selected-change", e);
    }
}
__decorate([
    attr()
], HamburgerMenuItem.prototype, "id", void 0);
